var _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _line, _line2, _line3, _line4, _path11, _path12, _line5, _line6, _line7, _line8, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _ellipse6, _path26, _path27, _path28, _path29, _circle, _circle2, _path30, _path31, _path32, _path33, _rect, _path34, _path35, _path36, _path37, _circle3, _circle4, _circle5, _path38, _path39, _path40, _path41, _rect2, _rect3, _ellipse7, _ellipse8, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _polygon, _polygon2, _polygon3, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _g, _path74, _ellipse9, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "76d98801-3a87-461e-b488-021b663cdcb4",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1056.29,
    height: 808.9,
    viewBox: "0 0 1056.29 808.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "on the way") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1107.7,264.1a257.25,257.25,0,0,0-41.89-66.76l-581.3-5.73,478.6-67.22A271.88,271.88,0,0,0,866,105.13a272.17,272.17,0,0,0-325.12-11,271,271,0,0,0-124.43-30c-129.16,0-236.78,89.46-260.92,208.08Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#34ccff",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.14,363.59a251.31,251.31,0,0,0-18.11-93.9L102.57,375.44A253,253,0,0,0,79,435.05l312,46.5L71.86,515.46c9.6,134.29,124.72,240.33,265.35,240.33,70.79,0,135.12-26.87,182.78-70.69,47.81,44.65,112.76,72.11,184.31,72.11,106.17,0,197.8-60.45,240.47-147.85,85.61-27.17,152.11-95.39,174.87-180.74L725.1,367.43h403C1128.12,366.15,1128.14,364.87,1128.14,363.59Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#34ccff",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.11,
    cy: 738.8,
    rx: 25.82,
    ry: 3.55,
    fill: "#34ccff",
    opacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.02,
    cy: 748.83,
    rx: 25.82,
    ry: 3.55,
    fill: "#34ccff",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.53,
    cy: 735.25,
    rx: 25.82,
    ry: 3.55,
    fill: "#34ccff",
    opacity: 0.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.43,
    cy: 777.39,
    rx: 18.36,
    ry: 2.52,
    fill: "#34ccff",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.1,
    cy: 774.87,
    rx: 18.36,
    ry: 2.52,
    fill: "#34ccff",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.44,793.58s-36.22-118.72,5.66-166.27c31.34-35.58,66.9-31.32,82.83-26.92a29.44,29.44,0,0,1,19,15.79c5.57,12,4.56,31.51-34.75,54.27-65.82,38.11-69.91,90.38-69.91,90.38Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#34ccff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M282.26,617.23S175.5,650.61,199.44,793.58",
    transform: "translate(-71.86 -45.55)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M219.91,629.2s14.7,9.9,10,24.79",
    transform: "translate(-71.86 -45.55)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M271.55,638s-9-9.14-19.92-4.1",
    transform: "translate(-71.86 -45.55)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M229.35,684s-15.78-8-19.86,2",
    transform: "translate(-71.86 -45.55)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.3,700.68s11.85-.94,12.07,4.73",
    transform: "translate(-71.86 -45.55)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198,794.53s42.42-86.29,54.07-84.4c5.53.9,8.08,6.34,9.24,11.81A34.8,34.8,0,0,1,259,743C253,756.75,236.78,783,198,794.53Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#34ccff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M251.72,726.51S207.2,791.07,198.6,793.9",
    transform: "translate(-71.86 -45.55)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 183.96,
    y1: 691.03,
    x2: 173.57,
    y2: 691.03,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 171.51,
    y1: 714.65,
    x2: 155.23,
    y2: 715.35,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 161.6,
    y1: 695.76,
    x2: 163.37,
    y2: 704.24,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 144.28,
    y1: 721.58,
    x2: 144.6,
    y2: 729.29,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M199.23,794.53s-42.42-86.29-54.07-84.4c-5.53.9-8.08,6.34-9.24,11.81a34.73,34.73,0,0,0,2.32,21C144.25,756.75,160.42,783,199.23,794.53Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#34ccff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145.48,726.51S190,791.07,198.6,793.9",
    transform: "translate(-71.86 -45.55)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 69.53,
    y1: 691.03,
    x2: 79.92,
    y2: 691.03,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 81.97,
    y1: 714.65,
    x2: 98.26,
    y2: 715.35,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 91.89,
    y1: 695.76,
    x2: 90.12,
    y2: 704.24,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 109.21,
    y1: 721.58,
    x2: 108.89,
    y2: 729.29,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M272.06,814.68a7.36,7.36,0,0,0,2.42-3.64,3.24,3.24,0,0,0-1.69-3.71c-1.55-.6-3.21.48-4.46,1.56s-2.7,2.33-4.34,2.1a6.61,6.61,0,0,0,2-6.18,2.58,2.58,0,0,0-.56-1.26c-.86-.92-2.42-.52-3.45.2-3.28,2.3-4.19,6.75-4.21,10.76a20.48,20.48,0,0,1-.06-4.43c0-1.48-.42-3.13-1.67-3.92a4.88,4.88,0,0,0-2.53-.6c-1.48,0-3.11.09-4.12,1.17-1.25,1.34-.93,3.58.16,5.06a16.12,16.12,0,0,0,4.26,3.41,9.51,9.51,0,0,1,3,2.9,3,3,0,0,1,.22.52h9.23A25.59,25.59,0,0,0,272.06,814.68Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#34ccff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M110.43,779.93a7.34,7.34,0,0,0,2.42-3.64,3.26,3.26,0,0,0-1.69-3.72c-1.55-.59-3.2.49-4.46,1.57s-2.69,2.32-4.34,2.09a6.58,6.58,0,0,0,2-6.18,2.61,2.61,0,0,0-.57-1.25c-.86-.92-2.42-.53-3.45.2-3.28,2.3-4.19,6.75-4.21,10.76a20.57,20.57,0,0,1-.06-4.44c0-1.48-.41-3.12-1.66-3.91a4.92,4.92,0,0,0-2.54-.6c-1.47-.06-3.11.09-4.12,1.17-1.25,1.34-.92,3.58.16,5a15.85,15.85,0,0,0,4.27,3.42,9.37,9.37,0,0,1,3,2.9,3.55,3.55,0,0,1,.23.52h9.23A25.76,25.76,0,0,0,110.43,779.93Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#34ccff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M164.3,814.68a7.36,7.36,0,0,0,2.42-3.64,3.24,3.24,0,0,0-1.69-3.71c-1.55-.6-3.21.48-4.46,1.56s-2.7,2.33-4.34,2.1a6.61,6.61,0,0,0,2-6.18,2.58,2.58,0,0,0-.56-1.26c-.86-.92-2.42-.52-3.45.2-3.28,2.3-4.19,6.75-4.21,10.76a20.48,20.48,0,0,1-.06-4.43c0-1.48-.41-3.13-1.66-3.92a4.94,4.94,0,0,0-2.54-.6c-1.47,0-3.11.09-4.12,1.17-1.25,1.34-.93,3.58.16,5.06a16.12,16.12,0,0,0,4.26,3.41,9.51,9.51,0,0,1,3,2.9,3,3,0,0,1,.22.52h9.23A25.59,25.59,0,0,0,164.3,814.68Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#34ccff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M317.07,744.43s3.46,4.53-1.6,11.36-9.22,12.6-7.54,16.86c0,0,7.63-12.69,13.84-12.87S323.9,752.06,317.07,744.43Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#34ccff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M317.07,744.43a5.74,5.74,0,0,1,.71,1.42c6.06,7.12,9.28,13.76,3.46,13.93-5.43.16-11.93,9.86-13.49,12.31.05.19.11.37.18.56,0,0,7.63-12.69,13.84-12.87S323.9,752.06,317.07,744.43Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M323.5,750.2c0,1.59-.18,2.88-.4,2.88s-.4-1.29-.4-2.88.23-.84.45-.84S323.5,748.61,323.5,750.2Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#ffd037"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M325.71,752.1c-1.4.76-2.62,1.22-2.72,1s.94-1,2.34-1.73.84-.21.95,0S327.11,751.34,325.71,752.1Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#ffd037"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M298.79,744.43s-3.46,4.53,1.6,11.36,9.23,12.6,7.54,16.86c0,0-7.63-12.69-13.84-12.87S292,752.06,298.79,744.43Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#34ccff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M298.79,744.43a5.55,5.55,0,0,0-.7,1.42c-6.06,7.12-9.29,13.76-3.47,13.93,5.43.16,11.94,9.86,13.5,12.31-.06.19-.12.37-.19.56,0,0-7.63-12.69-13.84-12.87S292,752.06,298.79,744.43Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M292.36,750.2c0,1.59.18,2.88.4,2.88s.4-1.29.4-2.88-.22-.84-.44-.84S292.36,748.61,292.36,750.2Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#ffd037"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M290.15,752.1c1.4.76,2.62,1.22,2.73,1s-.95-1-2.34-1.73-.85-.21-1,0S288.76,751.34,290.15,752.1Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#ffd037"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M293.46,772.05s9.68-.29,12.59-2.37,14.88-4.56,15.61-1.23,14.53,16.56,3.61,16.65-25.37-1.7-28.28-3.47S293.46,772.05,293.46,772.05Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#a8a8a8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M325.47,783.94c-10.92.09-25.38-1.7-28.29-3.47-2.22-1.35-3.1-6.19-3.39-8.43h-.33s.62,7.81,3.53,9.58,17.36,3.56,28.28,3.47c3.16,0,4.24-1.15,4.18-2.81C329,783.3,327.81,783.92,325.47,783.94Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.2
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 612.39,
    cy: 793.96,
    rx: 329.42,
    ry: 14.94,
    fill: "#34ccff",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M650.69,392.84s21,39.73,22.63,45.4a7.66,7.66,0,0,0,7.08,5.66s20.92,5,25.92,5.67,48.34,4.33,48.34,4.33,11,.34,12.33-3.66c1.22-3.66,22.47-22.89,34.77-6.11a12.23,12.23,0,0,1,1.78,10.92c-2.26,7.2-6.9,18.63-11.88,11.52-7-10-15.14-7.19-15.14-1.86s-11.2,3.35-14.86,4.1c-2,.41-8.88,2.24-14.83,3.84a108,108,0,0,1-21.12,3.51c-11.81.77-29.22,1.41-35.39-.92-7.45-2.83-20.44-3.48-26-3.63a8.55,8.55,0,0,1-5.07-1.82A79.09,79.09,0,0,1,640,447.9c-8.67-15-26.5-46.06-25.3-55.06S650.69,392.84,650.69,392.84Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#efb7b9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M650.69,392.84s21,39.73,22.63,45.4a7.66,7.66,0,0,0,7.08,5.66s20.92,5,25.92,5.67,48.34,4.33,48.34,4.33,11,.34,12.33-3.66c1.22-3.66,22.47-22.89,34.77-6.11a12.23,12.23,0,0,1,1.78,10.92c-2.26,7.2-6.9,18.63-11.88,11.52-7-10-15.14-7.19-15.14-1.86s-11.2,3.35-14.86,4.1c-2,.41-8.88,2.24-14.83,3.84a108,108,0,0,1-21.12,3.51c-11.81.77-29.22,1.41-35.39-.92-7.45-2.83-20.44-3.48-26-3.63a8.55,8.55,0,0,1-5.07-1.82A79.09,79.09,0,0,1,640,447.9c-8.67-15-26.5-46.06-25.3-55.06S650.69,392.84,650.69,392.84Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.05
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M891.6,693c-9.51,10.34-16.51,14.41-16.18,3.5,1-33-57-182.2-57-182.2l17.15-1.3C873,577.49,886.92,643.81,891.6,693Z",
    transform: "translate(-71.86 -45.55)",
    fill: "none"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M973.41,765A82.5,82.5,0,0,1,808.72,772c-.12-1.34-.21-2.68-.25-4v-.07q-.06-1.49-.06-3a82.5,82.5,0,0,1,165,0Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#65617d"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 819.05,
    cy: 719.4,
    r: 45,
    fill: "#dce0ed"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 819.05,
    cy: 719.4,
    r: 27,
    fill: "#65617d"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M674.25,608.28l-198.66,4V583c1.78-23.57,26-31.84,48-34.43a137.78,137.78,0,0,1,51.33,3.85c42.15,11.16,69,13.32,82.23,13.53a12.61,12.61,0,0,1,12.2,10.26c.63,3.35,1.25,7,1.83,10.6.44,2.82.86,5.6,1.24,8.19C673.52,602.46,674.25,608.28,674.25,608.28Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#65617d"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M832.74,770.28H420.05A16.25,16.25,0,0,1,405,760.55c-3.11-7.43,1.24-12.17,5.88-14.95a46.75,46.75,0,0,0,20.32-24.86c4.4-13,8.7-33.34,10.39-65.12,1.74-32.87,13.64-49.12,26.5-57h0c16.61-10.16,34.82-6.35,34.82-6.35l167.33,1.34a32.16,32.16,0,0,1,8.17,5.33c14.91,13.88-6.83,32-6.83,32-46.67,49.33-11.34,99.33-11.34,99.33h85.62a78.79,78.79,0,0,0,44.85-13.73c11.57-8,16-15.73,17.78-20.41,1.32-3.58,2.66-7.15,4.26-10.61,22.46-48.71-4.63-127.95-16.32-157.58-2.9-7.37-4.85-11.67-4.85-11.67l26.85-2,17-1.29h.17c37.42,64.54,51.33,130.86,56,180,.44,4.63.8,9.12,1.09,13.43A60,60,0,0,1,832.74,770.28Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#34ccff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M672.43,595H475.59v-8.19h195.6C671.63,589.58,672.05,592.36,672.43,595Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M678.42,599H469.68a4,4,0,0,1-1.58-.32c16.61-10.16,34.82-6.35,34.82-6.35l167.33,1.34A32.16,32.16,0,0,1,678.42,599Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 320.69,
    y: 543.21,
    width: 291.7,
    height: 8.19,
    rx: 4.09,
    ry: 4.09,
    fill: "#dce0ed"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M891.6,693c-9.51,10.34-16.51,14.41-16.18,3.5,1-33-57-182.2-57-182.2l17.15-1.3C873,577.49,886.92,643.81,891.6,693Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M972.91,755.91c-9.85,2.36-22,4.76-37,7q-8.37,1.23-18,2.36c-15.33,1.82-33.06,3.41-53.54,4.63q-8.7.52-18.07.95-17.55.8-37.57,1.22l-.25-4v-.07c18.65-7.53,48-27.62,52.72-79.95a82.54,82.54,0,0,1,111.72,67.94Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M792.92,770.28S887.62,760,855,615.71c0,0,46.79,42.9,75.9,66.74s81,56.71,81,56.71S980.92,768.11,792.92,770.28Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#34ccff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M792.92,770.28S887.62,760,855,615.71c0,0,46.79,42.9,75.9,66.74s81,56.71,81,56.71S980.92,768.11,792.92,770.28Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#fff",
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.06,
    cy: 719.4,
    r: 82.5,
    fill: "#65617d"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.06,
    cy: 719.4,
    r: 45,
    fill: "#dce0ed"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.06,
    cy: 719.4,
    r: 27,
    fill: "#65617d"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M632.42,740.17c0-53.27-42.31-96.46-94.5-96.46s-94.5,43.19-94.5,96.46q0,3.38.23,6.69H632.19Q632.42,743.55,632.42,740.17Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M628.92,738.51c0-51.3-40.74-92.89-91-92.89s-91,41.59-91,92.89c0,2.17.08,4.31.22,6.44H628.7C628.84,742.82,628.92,740.68,628.92,738.51Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#34ccff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M628.92,738.51c0,1.49,0,3-.11,4.44,0,.67-.07,1.33-.11,2H447.14c0-.67-.08-1.33-.11-2-.07-1.47-.11-3-.11-4.44,0-51.3,40.74-92.89,91-92.89S628.92,687.21,628.92,738.51Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#fff",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M628.81,743c0,.67-.07,1.33-.11,2H447.14c0-.67-.08-1.33-.11-2Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 335.25,
    y: 701.4,
    width: 244.48,
    height: 21.33,
    rx: 10.67,
    ry: 10.67,
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 335.25,
    y: 699.4,
    width: 244.48,
    height: 21.33,
    rx: 10.67,
    ry: 10.67,
    fill: "#dce0ed"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 862.9,
    cy: 578.3,
    rx: 11.98,
    ry: 30.16,
    transform: "translate(-233.48 361.37) rotate(-24.33)",
    opacity: 0.1
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 863.9,
    cy: 577.3,
    rx: 11.98,
    ry: 30.16,
    transform: "translate(-232.98 361.69) rotate(-24.33)",
    fill: "#dce0ed"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M835.42,513v15.67h-30.5a52.55,52.55,0,0,1-8.48-.68c-2.9-7.37-4.85-11.67-4.85-11.67l26.85-2Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M835.42,526.63h-30.5c-26.79,0-48.5-20-48.5-44.77v-4.15c0-24.72,21.71-44.76,48.5-44.76l30.5,2.77Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#34ccff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M785.17,459.45s18.25,9.75,7.75,26.25c0,0-12.88,21.12-33.13,19.12l-7.37-45.37S776.67,457.2,785.17,459.45Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#34ccff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M778.16,458.57A19.4,19.4,0,0,1,793,466.39c3.25,4.5,5.19,11.06-.06,19.31,0,0-12.88,21.12-33.13,19.12l-7.37-45.37S767.61,458,778.16,458.57Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M762.56,390.17h5.88a18.62,18.62,0,0,1,18.62,18.62v53.68a18.62,18.62,0,0,1-18.62,18.62h-5.88a0,0,0,0,1,0,0V390.17A0,0,0,0,1,762.56,390.17Z",
    opacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M763.56,390.17h5.88a18.62,18.62,0,0,1,18.62,18.62v53.68a18.62,18.62,0,0,1-18.62,18.62h-5.88a0,0,0,0,1,0,0V390.17A0,0,0,0,1,763.56,390.17Z",
    fill: "#dce0ed"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M618.88,552.48s4.71,1.72,11,4.12c10,3.85,24.1,9.47,29,12.55s23.17,8.14,36.85,11.7a120,120,0,0,0,31.06,3.83c10.64-.1,23.53-.2,27.09-.2a11.2,11.2,0,0,1,1.86.14c3.74.62,3.59,3.13,3.5,3.73l0,.13c-22,13.33-48.67,73-50.33,83-1.25,7.5-12.24,28.29-17.66,38.23-1.82,3.33-3,5.44-3,5.44l6.67,7.66,19.33,8.67,18.33,8s19.34,1,19.67,0,.33-11.33.33-11.33a54.6,54.6,0,0,1-6.68-5.08,110.51,110.51,0,0,1-12.32-12.59c-10.66-12.67,10.67-37,10.67-37l41-53.33s3.33-6,19.33-30,0-37,0-37l-28.16-11.69c-48.84-18.28-107.75-32.93-107.75-32.93l-.84-.11-12.49-1.56Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#efb7b9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M744.71,731.48s3.5,4.13.88,4.5-9.5-1.12-9.5-1.12l-43.63-23s-4.75-3.38-5.87,3.25-1.88,6-1.88,6-5.75,12.37,0,14.93S725,748.73,725,748.73s50.13,11.38,54.88-1.75-8.5-10.87-8.5-10.87-16.5-4-22.13-12C749.21,724.11,741.09,726.36,744.71,731.48Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#444053"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M804.54,553.15l-28.16-11.69c-48.84-18.28-107.75-32.93-107.75-32.93l-.84-.11-12.49-1.56-36.42,45.62s4.71,1.72,11,4.12c10,3.85,24.1,9.47,29,12.55s23.17,8.14,36.85,11.7a120,120,0,0,0,31.06,3.83c10.64-.1,23.53-.2,27.09-.2a11.2,11.2,0,0,1,1.86.14c3.74.62,3.59,3.13,3.5,3.73l0,.13c-22,13.33-48.67,73-50.33,83-1.25,7.5-12.24,28.29-17.66,38.23l-.73,1.34c-1.45-.24-3.26.28-3.9,4.06-1.13,6.62-1.88,6-1.88,6s-5.75,12.37,0,14.93S725,748.73,725,748.73s50.13,11.38,54.88-1.75-8.5-10.87-8.5-10.87-16.5-4-22.13-12a11.07,11.07,0,0,0-1.46.54c-.59-.48-1.22-1-1.89-1.58a110.51,110.51,0,0,1-12.32-12.59c-10.66-12.67,10.67-37,10.67-37l41-53.33s3.33-6,19.33-30S804.54,553.15,804.54,553.15Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.05
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M585.3,329.46l1.52,1.92.85,1.07,5.3,6.67s12.65,4.06,23.74,6.69c11.55,2.73,21.4,3.92,13.57-2.61-4.86-4.05-5.18-10.83-3.41-18.1A74.9,74.9,0,0,1,633.23,309q.59-1.14,1.17-2.22a133.43,133.43,0,0,1,8.24-13.31,236.63,236.63,0,0,0-22.09-13.57c-9.16-4.74-16.68-6.81-11.91,2.57,3.06,6,2.06,12.74-.8,19.19-.22.51-.46,1-.71,1.53a68.78,68.78,0,0,1-9.44,13.89A109.62,109.62,0,0,1,585.3,329.46Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#efb7b9"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "576.78 436.24 583.56 442.43 590.11 467.63 579.18 467.63 567.11 451.93 576.78 436.24",
    fill: "#444053"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "567.11 451.93 574.41 461.42 579.18 467.63 590.11 467.63 588.99 463.32 584.22 444.96 583.56 442.43 576.78 436.24 567.52 451.26 567.11 451.93",
    opacity: 0.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "567.11 451.93 574.41 461.42 579.18 467.63 590.11 467.63 588.99 463.32 584.22 444.96 583.56 442.43 576.78 436.24 567.52 451.26 567.11 451.93",
    opacity: 0.1
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M602.64,563.79s4.71,1.72,11,4.12c10,3.85,24.1,9.47,29,12.55s23.17,8.14,36.85,11.7A120,120,0,0,0,710.55,596c10.64-.1,23.53-.2,27.09-.2a11.2,11.2,0,0,1,1.86.14c3.74.62,3.59,3.13,3.5,3.73l0,.13c-22,13.33-48.67,73-50.33,83-1.25,7.5-12.24,28.29-17.66,38.23-1.82,3.33-3,5.44-3,5.44l6.67,7.66L698,742.79l18.33,8s19.34,1,19.67,0,.33-11.33.33-11.33a54.6,54.6,0,0,1-6.68-5.08,110.51,110.51,0,0,1-12.32-12.59c-10.66-12.67,10.67-37,10.67-37l41-53.33s3.33-6,19.33-30,0-37,0-37l-25.66-14.67c-40-24.33-96.34-38.33-96.34-38.33l-.84-.11L653,509.79Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#efb7b9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M672,726.46l6.67,7.66L698,742.79l18.33,8s19.34,1,19.67,0,.33-11.33.33-11.33a54.6,54.6,0,0,1-6.68-5.08c-2.07,1.11-4.42,3.19-2.15,6.41,0,0,3.5,4.12.88,4.5s-9.5-1.12-9.5-1.12l-43.63-23L675,721C673.16,724.35,672,726.46,672,726.46Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M728.47,742.79s3.5,4.12.87,4.5-9.5-1.13-9.5-1.13l-43.62-23s-4.75-3.37-5.88,3.25-1.87,6-1.87,6-5.75,12.38,0,14.94S708.72,760,708.72,760s50.12,11.37,54.87-1.75-8.5-10.88-8.5-10.88-16.5-4-22.12-12C733,735.41,724.84,737.66,728.47,742.79Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#444053"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M605.3,299.12c5.78,4,14.6,10.33,22.13,10.33a36.91,36.91,0,0,0,5.8-.46,135.17,135.17,0,0,1,9.41-15.53s-44-30.67-34-11C611.94,289,608.69,292.21,605.3,299.12Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M591.43,271.45a35.94,35.94,0,0,0,16.41,30.2,33.06,33.06,0,0,0,3.52,2,36,36,0,1,0-19.93-32.22Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#efb7b9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M602.64,563.79s4.71,1.72,11,4.12c3.95-3.48,8-6.84,9.69-7.45,3.67-1.34,15.67-8.34,15.34-10.34s5-9.66,9.66-11,2-8.33,2-8.33,9-3.33,11.24-8,9.1-10.67,6.76-10.33a7.26,7.26,0,0,1-2.84-1.11L653,509.79Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M575.3,551.79s15.34,12.67,16.05,18.33,10.95,5.34,10.95,5.34,15.34-14.67,19-16,15.67-8.34,15.34-10.34,5-9.66,9.66-11,2-8.33,2-8.33,9-3.33,11.24-8,9.1-10.67,6.76-10.33c-.66.09-2.77-1-5.45-2.59-3.29-2-7.46-4.71-10.86-7-3.6-2.44-6.35-4.38-6.35-4.38s-1.57-.28-4.26-.67c-14.51-2.1-61.77-7.46-72.74,10a26.47,26.47,0,0,0-3.25,7.47C558.48,532.89,575.3,551.79,575.3,551.79Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#444053"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M591.34,511.37s-15.66,8.84-21.5,8.84S591.34,511.37,591.34,511.37Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M601.8,518.12s-23.32,7.84-23.32,14S576.3,515.62,601.8,518.12Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M657.63,482.81l-.33.45A1,1,0,0,0,657.63,482.81Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M585.3,329.46l1.52,1.92.85,1.07,5.3,6.67s12.65,4.06,23.74,6.69c11.55,2.73,21.4,3.92,13.57-2.61-4.86-4.05-5.18-10.83-3.41-18.1l-.35-.45s.35,6.74-3.64,6.87c-5.38.17-5.45-1.64-10.41-3.73-6.39-2.7-12.94-7.21-14.78-10.72A109.62,109.62,0,0,1,585.3,329.46Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M563.39,514.26a11.55,11.55,0,0,0,8.58.2c10.33-3.34,26.67-11.38,34.33-7.86,6.14,2.82,30.87,2.74,40,.37,2.27-.59,3.57-1.32,3.37-2.18a6,6,0,0,1,.35-2.93c1.06-3.39,3.94-8.1,6.09-11.35l-.66-2.53-6.78-6.19-9.26,15c-14.51-2.1-61.77-7.46-72.74,10A26.47,26.47,0,0,0,563.39,514.26Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M556.64,506.46s4,9.33,14.33,6,26.67-11.38,34.33-7.86,44.34,2.52,43.34-1.81,9-18,9-18-5.46-1-8.84-18.83c-.5-2.6-.95-5.56-1.33-8.92a113.52,113.52,0,0,1-.58-20.74C648.24,417,655,409.12,655,409.12s9.33-10.66,1.33-25.33c-4.19-7.69-21.1-29-21.33-38.5-.21-8.62-8.45-18.64-8.45-18.64s.35,6.74-3.64,6.87c-5.38.17-5.45-1.64-10.41-3.73-7.29-3.08-14.78-8.51-15.27-12.14,0,0-30.56-1.53-37.23,29.47s-4.33,48-3.33,51.67,9.66,51,2.66,71S556.64,506.46,556.64,506.46Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#a36468"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M606.47,452a78.42,78.42,0,0,0,21.66,23.67,150.09,150.09,0,0,1,17.5,1.17c-.5-2.6-1-5.56-1.33-8.92a113.52,113.52,0,0,1-.58-20.74,7.55,7.55,0,0,1-3.92-4.84c-1.67-5.67-16.54-32.67-16.54-32.67s-34.79-9-36,0S597.8,437,606.47,452Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M618,392.84s21,39.73,22.63,45.4a7.66,7.66,0,0,0,7.08,5.66s20.92,5,25.92,5.67S722,453.9,722,453.9s11,.34,12.33-3.66c1.22-3.66,22.47-22.89,34.77-6.11a12.23,12.23,0,0,1,1.78,10.92c-2.26,7.2-6.9,18.63-11.88,11.52-7-10-15.14-7.19-15.14-1.86s-11.2,3.35-14.86,4.1c-2,.41-8.88,2.24-14.83,3.84A108,108,0,0,1,693,476.16c-11.81.77-29.22,1.41-35.39-.92-7.44-2.83-20.43-3.48-26-3.63a8.55,8.55,0,0,1-5.07-1.82A79.09,79.09,0,0,1,607.3,447.9c-8.67-15-26.5-46.06-25.3-55.06S618,392.84,618,392.84Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#efb7b9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M611,337.79s11.25,18.67,16.46,32S639,406.46,639,406.46l-31.34-3.67L605,398.46s-22.38,14-19.71,20-6-9-5.33-26-2.41-47.34,0-54.67S603.63,332.12,611,337.79Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M580,390.46c-.67,17,8,32,5.33,26s19.71-20,19.71-20l2.63,4.33L639,404.46s-6.33-23.34-11.54-36.67a203.94,203.94,0,0,0-10.72-22c-3.21-5.83-5.74-10-5.74-10-4.31-3.33-13.46-5.28-20.76-4.82a26.88,26.88,0,0,0-3.39.41c-3,.59-5.42,1.73-6.49,3.53a4.66,4.66,0,0,0-.4.88C577.56,343.12,580.64,373.46,580,390.46Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#a36468"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M566,437s13.25,18.25,17.25,18.75C583.22,455.79,566.22,452,566,437Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M566,463s25,25.25,33,25.5S566,463,566,463Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M566,473.54s16,18.75,17,18.75S565.72,485.79,566,473.54Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M580.33,334.91a22.18,22.18,0,0,0,7.34-2.46c.86-.45,1.71-.95,2.54-1.48a60.07,60.07,0,0,0,9.12-7.5c4.6-4.47,9.19-9.35,11.09-15.48a27.87,27.87,0,0,0,.94-4.32c1.14-7.69.18-16.18,5.68-21.41a13.08,13.08,0,0,1,3.51-2.37c7.8-3.71,19.11-1.31,24.93-8,3.7-4.24,3.61-10.13,6.45-14.74,1.24-2,3.52-3.73,5.54-5.57a36,36,0,1,0-49.63,50c-.22.51-.46,1-.71,1.53-6.87,14-21.83,26.28-21.83,26.28l1.52,1.92C583.79,332,581.4,333.11,580.33,334.91Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M643.48,270.91c-6.77,7.76-21,3.24-28.45,10.35-6.54,6.23-3.94,17.1-6.61,25.73-1.9,6.13-6.49,11-11.09,15.48-6.7,6.52-15.27,13.14-24.43,11.27-5.43-1.11-10.75-5.17-16-3.3-2.61.94-4.48,3.2-6.43,5.19a44.31,44.31,0,0,1-24.57,12.71,10.51,10.51,0,0,1-5.57-.26c-2.8-1.14-4.31-4.2-6.86-5.83-5-3.2-11.42.08-16.61,2.94a116.23,116.23,0,0,1-95.48,6.87l8.09-4c-1.72-3.51-6.37-4.28-9.33-6.85-6.1-5.29-2.51-15.87,3.94-20.72s14.8-6.54,21.48-11.07c1.36-.92,2.74-2.14,2.87-3.77a6,6,0,0,0-1.09-3.34c-3.56-6.27-7.5-13-6.7-20.17,1.22-11,13.23-17.76,24.26-18.53s21.95,2.55,33,2.74c4,.07,8.19-.32,11.62-2.39,4.79-2.88,7.2-8.37,10.11-13.14A53.67,53.67,0,0,1,521.13,231c10-5.05,21.32-6.82,31.72-11,10.62-4.26,20.28-11,31.39-13.71,16.13-4,33.41,1.23,47.34,10.27,6.71,4.35,28.14,18.31,28,27.24-.11,5.3-7,8.17-9.61,12.33C647.09,260.78,647.18,266.67,643.48,270.91Z",
    transform: "translate(-71.86 -45.55)",
    fill: "#965d7b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.36,297.3a6.09,6.09,0,0,1,1.09,3.34,3.38,3.38,0,0,1-.35,1.21c-2.94-5.18-6-10.67-6.49-16.45C421.91,289.53,424.2,293.5,426.36,297.3Z",
    transform: "translate(-71.86 -45.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.16,336.2c2.95,2.57,7.6,3.34,9.33,6.85l-2.86,1.42a32.17,32.17,0,0,1-5.47-3.27,9.41,9.41,0,0,1-3.12-7.77A8.59,8.59,0,0,0,399.16,336.2Z",
    transform: "translate(-71.86 -45.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.88,340.19c5.19-2.86,11.62-6.14,16.61-2.94,2.54,1.63,4.06,4.69,6.86,5.83a10.47,10.47,0,0,0,5.56.26,44.34,44.34,0,0,0,24.58-12.71c1.94-2,3.81-4.25,6.43-5.19,5.22-1.87,10.54,2.19,16,3.3,9.16,1.87,17.72-4.75,24.43-11.27,4.6-4.47,9.18-9.35,11.08-15.48,2.68-8.63.08-19.5,6.62-25.73,7.47-7.11,21.67-2.59,28.45-10.35,3.69-4.24,3.61-10.13,6.45-14.74,2.4-3.89,8.62-6.65,9.5-11.34a8.7,8.7,0,0,1,1.11,4c-.11,5.3-7,8.17-9.61,12.33-2.84,4.61-2.76,10.5-6.45,14.74-6.78,7.76-21,3.24-28.45,10.35-6.54,6.23-3.94,17.1-6.62,25.73-1.9,6.13-6.48,11-11.08,15.48-6.71,6.52-15.27,13.14-24.43,11.27-5.44-1.11-10.76-5.17-16-3.3-2.62.94-4.49,3.2-6.43,5.19a44.34,44.34,0,0,1-24.58,12.71,10.47,10.47,0,0,1-5.56-.26c-2.8-1.14-4.32-4.2-6.86-5.83-5-3.2-11.42.08-16.61,2.94a116.23,116.23,0,0,1-95.48,6.87l5.59-2.77A116.45,116.45,0,0,0,495.88,340.19Z",
    transform: "translate(-71.86 -45.55)"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M743,599.66l8.41-4.07V594c0-.61-6.71.74-11.91,1.89C743.24,596.55,743.09,599.06,743,599.66Z",
    transform: "translate(-71.86 -45.55)",
    opacity: 0.1
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 678.45,
    cy: 437.5,
    rx: 20.26,
    ry: 24.65,
    fill: "#34ccff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "483.45 405.42 450.88 437.54 343.81 435.67 373.25 405.42 483.45 405.42",
    fill: "#dda2a6"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "483.45 515.3 483.45 405.42 450.88 437.54 450.88 545.06 483.45 515.3",
    fill: "#b77b7f"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "343.81 435.67 343.81 545.06 450.88 545.06 450.88 437.54 343.81 435.67",
    fill: "#dda2a6"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "343.81 435.67 343.81 545.06 450.88 545.06 450.88 437.54 343.81 435.67",
    fill: "#fff",
    opacity: 0.3
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "442.18 467.65 362.55 453.98 352.17 506.26 434.15 521.32 442.18 467.65",
    fill: "#dce0ed"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "426.45 479.86 372.92 471.45 371.58 478.43 425.11 487.51 426.45 479.86",
    fill: "#34ccff"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "411.73 494.79 381.28 490.37 379.94 498.12 411.73 502.58 411.73 494.79",
    fill: "#34ccff"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "470.28 463.09 468.83 419.83 460.46 428.09 461.92 471.45 470.28 463.09",
    fill: "#65617d"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "362.48 416.49 465.37 417.88 468.83 419.83 460.46 428.09 457.57 426.39 355.66 423.5 362.48 416.49",
    fill: "#65617d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.ccf105792aef039bee51c26a007f82c3.svg";
export { ForwardRef as ReactComponent };